import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DetailedScheduledInstallmentPlan from './DetailedScheduledInstallmentPlan';

class DetailedScheduledInstallmentPlanModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleShow() {
    this.setState({ show: true, });
  }

  handleClose() {
    this.setState({ show: false, });
  }

  render() {
    const { show, } = this.state;
    const { scheduledInstallmentPlan, } = this.props;
    return (
      <>
        <Button variant="primary" onClick={this.handleShow}>
          Details
        </Button>

        <Modal show={show} onHide={this.handleClose} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>{`Managed Pay Installment Plan: ${scheduledInstallmentPlan.scheduledInstallmentPlanId}`}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {(() => {
              if (show) {
                return <DetailedScheduledInstallmentPlan scheduledInstallmentPlan={scheduledInstallmentPlan} />;
              }
              return undefined;
            })()}
          </Modal.Body>
          <Modal.Footer />
        </Modal>
      </>
    );
  }
}

DetailedScheduledInstallmentPlanModal.propTypes = {
  scheduledInstallmentPlan: PropTypes.instanceOf(Object).isRequired,
};

export default DetailedScheduledInstallmentPlanModal;
